export interface Quality {
  id?: number;
  name: string;
  description?: string;
  is_active?: boolean;
}

export interface QualityFilters {
  name?: string | '';
  is_active?: boolean | '';
  page: number;
  per_page: number;
  sort: string;
  order: string;
}

export const defaultQualityFilters: QualityFilters = {
  page: 1,
  per_page: 10,
  sort: 'id',
  order: 'asc'
};
